import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { CURRENCY_OPTIONS } from '../../../../../utils/compound-interest/constants';
import { cn } from '../../../../../utils/tailwind';
import { useCompoundInterestCalculatorContext } from '../../calculator-context/compound-interest-calculator-context';

export const CompoundInterestCurrencySwitcher: React.FC = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { params, handleCurrencyChange } = useCompoundInterestCalculatorContext();

    const frequencyOptionClass = (isActive: boolean) =>
        cn(
            'cursor-pointer rounded-[99rem] border-none px-[1.2rem] text-small font-bold transition-all duration-200',
            isActive
                ? 'bg-brand-primary text-text-inverse'
                : 'bg-transparent text-neutral-gray hover:bg-[var(--toggle-hover-bg)]',
        );

    return (
        <div className="flex min-h-[4rem] w-full flex-nowrap items-center justify-between gap-[1rem] vl:justify-start">
            <span className="text-small font-medium text-text-muted">
                {t('pages.compoundInterest.calculator.currency')}
            </span>
            <div
                className="flex h-[4rem] gap-[0.3rem] rounded-[99rem] p-[0.3rem]"
                style={{
                    background: theme.select.base.open.background,
                    ['--toggle-hover-bg' as string]: `${theme.palette.common.border}30`,
                }}
            >
                {CURRENCY_OPTIONS.map((currency) => (
                    <button
                        key={currency}
                        type="button"
                        className={frequencyOptionClass(params.currency === currency)}
                        onClick={() => handleCurrencyChange(currency)}
                    >
                        {currency}
                    </button>
                ))}
            </div>
        </div>
    );
};
